<template>
    <div class="ringAdd">
        <div class="ringMain">
            <el-form @submit.native.prevent class="ringForm tableSearchForm"  size="mini" label-width="auto" label-position="left" :model="addForm" :rules="rules" ref="ruleForm">
                <div class="ringFormHead">
                    <el-form-item :label="$t('systemSetting.dyName')" required><el-input v-model="addForm.envName" :placeholder="$t('systemSetting.dyName')" maxlength="8"></el-input></el-form-item>
                    <el-form-item :label="$t('systemSetting.enName')" required><el-input v-model="addForm.envNameEn" :placeholder="$t('systemSetting.enName')" ></el-input></el-form-item>
                    <el-form-item :label="$t('systemSetting.ordNum')" required><el-input v-model="addForm.envSort" :placeholder="$t('systemSetting.ordNum')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input></el-form-item>
                    <el-form-item :label="$t('systemSetting.icon')" required>
                        <el-select popper-class="selectDown" v-model="addForm.envIcon" :placeholder="$t('ems.strategy.PleaseSelectTip')">
                            <template v-for="(item, key) in iconOption">
                                <el-option :label="item.name" :value="item.value" :key="key"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('systemSetting.Enable')" required>
                        <el-select popper-class="selectDown" v-model="addForm.enabled">
                            <el-option :label="$t('ems.strategy.ToEnable')" :value="1"></el-option>
                            <el-option :label="$t('ems.strategy.Forbidden')" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div style="padding-left: 10px; margin-bottom: 10px">
                    <el-button size="small" @click="add(true)" icon="el-icon-plus">{{$t('systemSetting.PositiveAddition')}}</el-button>
                    <el-button size="small" @click="add(false)" icon="el-icon-plus">{{$t('systemSetting.ReverseAddition')}}</el-button>
                </div>

                <div class="fieldBox">
                    <div class="frontBackPage">
                        <div class="pageTitle">{{$t('systemSetting.RightSide')}}</div>

                        <template v-if="addForm.frontPage.length > 0">
                            <div class="fieldItem" v-for="(item, index) in addForm.frontPage" :key="index">
                                <div class="ringFormItem">
                                    <el-form-item :label="$t('systemSetting.ordNum')" required><el-input v-model="item.sort" :placeholder="$t('systemSetting.ordNum')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.AttributeType')" required>
                                        <el-select popper-class="selectDown" v-model="item.type">
                                            <el-option :label="$t('systemSetting.ReadOnly')" :value="1"></el-option>
                                            <el-option :label="$t('systemSetting.readWrite')" :value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item :label="$t('systemSetting.Attrname')" required><el-input v-model="item.name" :placeholder="$t('systemSetting.Attrname')" ></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.enName')"  required><el-input v-model="item.nameEn" :placeholder="$t('systemSetting.enName')" ></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.AttrUnit')"><el-input v-model="item.unit" :label="$t('systemSetting.AttrUnit')"></el-input></el-form-item>
                                </div>
                                <div class="ringFormItem">
                                    <el-form-item :label="$t('systemSetting.ReadFrom')"  :required="item.type == 1"><el-input v-model="item.readIdentifier" placeholder="Identifier" ></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.ReadField')" :required="item.type == 1"><el-input v-model="item.readTag" placeholder="TagNo"></el-input></el-form-item>
                                    <template v-if="item.type == 1">
                                        <div class="el-form-item1" style="text-align: center">
                                            <el-checkbox v-model="item.hasDict" style="margin-right: 5px"></el-checkbox>
                                            <span>{{$t('systemSetting.dictRequired')}}</span>
                                        </div>
                                        <div class="el-form-item1" style="width: 40%;">
                                            <div class="dictBox"  v-if="(item.type === 1 && item.hasDict)">
                                                <div style="display: flex; padding-left: 12px;">
                                                    <el-form-item :label="$t('systemSetting.attrKeyName')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.key" style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item :label="$t('systemSetting.attrKeyValue')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.value"  style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item label-width="60" style="width: auto;  padding-right: 5px"> <el-color-picker v-model="item.color"></el-color-picker></el-form-item>
                                                    <div style="width: auto">
                                                        <el-button size="mini" @click="addDict(true, index)">{{$t('ems.add')}}</el-button>
                                                    </div>
                                                </div>
                                                <el-table :data="item.readDict" style="width: 100%" border size="mini" height="150" class="minRingTable">
                                                    <el-table-column  :label="$t('systemSetting.attrKeyName')" prop="key">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.color" :style="{ color: scope.row.color }">{{ scope.row.key }}</span>
                                                            <span v-else>{{ scope.row.key }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column  :label="$t('systemSetting.attrKeyValue')"  prop="value"></el-table-column>
                                                    <el-table-column  :label="$t('ems.alarm.operation')" align="center">
                                                        <template slot-scope="scope">
                                                            <el-button @click.native.prevent="deleteDict(true, index, scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <el-form-item :label="$t('systemSetting.writeFrom')" required><el-input v-model="item.writeIdentifier" placeholder="Identifier"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.writeField')" required><el-input v-model="item.writeTag" placeholder="TagNo"></el-input></el-form-item>
                                        <el-form-item style="width: 20%"></el-form-item>
                                    </template>
                                </div>
                                <div class="ringFormItem"  v-if="item.type !== 1">
                                    <el-form-item :label="$t('systemSetting.AttributeType')" required style="width: 250px">
                                        <el-select popper-class="selectDown" v-model="item.writeType">
                                            <el-option :label="$t('systemSetting.Operationbuttononly')"  :value="1"></el-option>
                                            <el-option :label="$t('systemSetting.Button_input_box')" :value="2"></el-option>
                                            <el-option :label="$t('systemSetting.Button_select')" :value="3"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <template v-if="item.writeType != 2">
                                        <el-form-item style="width: 80%"></el-form-item>
                                    </template>
                                    <template v-else>
                                        <div class="el-form-item">
                                            <el-radio-group v-model="item.writeInputType" size="mini">
                                                <el-radio :label="0">{{$t('systemSetting.TextBox')}}</el-radio>
                                                <el-radio :label="1">{{$t('systemSetting.NumberBox')}}</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <el-form-item style="width: 40%"></el-form-item>
                                    </template>
                                </div>
                                <div class="ringFormItem"  v-if="item.type !== 1">

                                    <template v-if="item.writeType  == 1">
                                        <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.btnName" :placeholder="$t('systemSetting.btnCNName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.btnNameEn" :placeholder="$t('systemSetting.btnENName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnValue')" required><el-input v-model="item.btnInputDefault" :placeholder="$t('systemSetting.btnValue')"></el-input></el-form-item>
                                        <el-form-item></el-form-item>
                                        <el-form-item></el-form-item>
                                    </template>
                                    <template v-else-if="item.writeType  == 2">
                                        <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.btnName" :placeholder="$t('systemSetting.btnCNName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.btnNameEn" :placeholder="$t('systemSetting.btnENName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.Default')"><el-input v-model="item.btnInputDefault" :placeholder="$t('systemSetting.Default')"></el-input></el-form-item>
                                        <template v-if="item.writeInputType == 1">
                                            <el-form-item :label="$t('systemSetting.max')"><el-input v-model="item.max" oninput="value=value.replace(/[^\-?\d.]/g,'')"></el-input></el-form-item>
                                            <el-form-item :label="$t('systemSetting.min')"><el-input v-model="item.min" oninput="value=value.replace(/[^\-?\d.]/g,'')"></el-input></el-form-item>
                                        </template>
                                        <template v-else>
                                            <el-form-item style="width: 40%"></el-form-item>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.btnName" :placeholder="$t('systemSetting.btnCNName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.btnNameEn" :placeholder="$t('systemSetting.btnENName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.Default')"><el-input v-model="item.btnInputDefault" :placeholder="$t('systemSetting.Default')"></el-input></el-form-item>
                                        <div class="el-form-item1" style="width: 40%;">
                                            <div class="dictBox"  v-if="(item.type === 2 && item.writeType === 3)">
                                                <div style="display: flex; padding-left: 12px;">
                                                    <el-form-item :label="$t('systemSetting.attrKeyName')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.key" style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item :label="$t('systemSetting.attrKeyValue')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.value"  style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item label-width="60" style="width: auto;  padding-right: 5px"> <el-color-picker v-model="item.color"></el-color-picker></el-form-item>
                                                    <div style="width: auto">
                                                        <el-button size="mini" @click="addDict(true, index)">{{$t('ems.add')}}</el-button>
                                                    </div>
                                                </div>
                                                <el-table :data="item.readDict" style="width: 100%" border size="mini" height="150" class="minRingTable">
                                                    <el-table-column  :label="$t('systemSetting.attrKeyName')" prop="key">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.color" :style="{ color: scope.row.color }">{{ scope.row.key }}</span>
                                                            <span v-else>{{ scope.row.key }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column  :label="$t('systemSetting.attrKeyValue')" prop="value"></el-table-column>
                                                    <el-table-column  :label="$t('ems.alarm.operation')" align="center">
                                                        <template slot-scope="scope">
                                                            <el-button @click.native.prevent="deleteDict(true, index, scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="ringFormItem"></div>
                                <div class="deleteBtn">
                                    <el-button size="mini" @click="remove(true, index)">{{ $t('ems.alarm.delete') }}</el-button>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="emptyText">{{$t('systemSetting.addTips')}}</div>
                        </template>
                    </div>
                    <div class="frontBackPage">
                        <div class="pageTitle">{{$t('systemSetting.ReverseSide')}}</div>
                        <template v-if="addForm.backPage.length > 0">
                            <div class="fieldItem" v-for="(item, index) in addForm.backPage" :key="index">
                                <div class="ringFormItem">
                                    <el-form-item :label="$t('systemSetting.ordNum')" required><el-input v-model="item.sort" :placeholder="$t('systemSetting.ordNum')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.AttributeType')" required>
                                        <el-select popper-class="selectDown" v-model="item.type">
                                            <el-option :label="$t('systemSetting.ReadOnly')" :value="1"></el-option>
                                            <el-option :label="$t('systemSetting.readWrite')" :value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.name" :placeholder="$t('systemSetting.btnCNName')" ></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.nameEn" :placeholder="$t('systemSetting.btnENName')" ></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.AttrUnit')"><el-input v-model="item.unit" :placeholder="$t('systemSetting.AttrUnit')" ></el-input></el-form-item>
                                </div>
                                <div class="ringFormItem">
                                    <el-form-item :label="$t('systemSetting.ReadFrom')"  :required="item.type == 1"><el-input v-model="item.readIdentifier" placeholder="Identifier" ></el-input></el-form-item>
                                    <el-form-item :label="$t('systemSetting.ReadField')" :required="item.type == 1"><el-input v-model="item.readTag" placeholder="TagNo"></el-input></el-form-item>
                                    <template v-if="item.type == 1">
                                        <div class="el-form-item1" style="text-align: center">
                                            <el-checkbox v-model="item.hasDict" style="margin-right: 5px"></el-checkbox>
                                            <span>{{$t('systemSetting.dictRequired')}}</span>
                                        </div>
                                        <div class="el-form-item1" style="width: 40%;">
                                            <div class="dictBox"  v-if="(item.type === 1 && item.hasDict)">
                                                <div style="display: flex; padding-left: 12px;">
                                                    <el-form-item :label="$t('systemSetting.attrKeyName')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.key" style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item :label="$t('systemSetting.attrKeyValue')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.value"  style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item label-width="60" style="width: auto;  padding-right: 5px"> <el-color-picker v-model="item.color"></el-color-picker></el-form-item>
                                                    <div style="width: auto">
                                                        <el-button size="mini" @click="addDict(false, index)">{{$t('ems.add')}}</el-button>
                                                    </div>
                                                </div>
                                                <el-table :data="item.readDict" style="width: 100%" border size="mini" height="150" class="minRingTable">
                                                    <el-table-column  :label="$t('systemSetting.attrKeyName')" prop="key">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.color" :style="{ color: scope.row.color }">{{ scope.row.key }}</span>
                                                            <span v-else>{{ scope.row.key }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column  :label="$t('systemSetting.attrKeyValue')" prop="value"></el-table-column>
                                                    <el-table-column  :label="$t('ems.alarm.operation')" align="center">
                                                        <template slot-scope="scope">
                                                            <el-button @click.native.prevent="deleteDict(false, index, scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <el-form-item :label="$t('systemSetting.writeFrom')" required><el-input v-model="item.writeIdentifier" placeholder="Identifier"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.writeField')" required><el-input v-model="item.writeTag" placeholder="TagNo"></el-input></el-form-item>
                                        <el-form-item style="width: 20%"></el-form-item>
                                    </template>
                                </div>
                                <div class="ringFormItem"  v-if="item.type !== 1">
                                    <el-form-item :label="$t('systemSetting.AttributeType')" required style="width: 250px">
                                        <el-select popper-class="selectDown" v-model="item.writeType">
                                            <el-option :label="$t('systemSetting.Operationbuttononly')"  :value="1"></el-option>
                                            <el-option :label="$t('systemSetting.Button_input_box')" :value="2"></el-option>
                                            <el-option :label="$t('systemSetting.Button_select')" :value="3"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <template v-if="item.writeType != 2">
                                        <el-form-item style="width: 80%"></el-form-item>
                                    </template>
                                    <template v-else>
                                        <div class="el-form-item">
                                            <el-radio-group v-model="item.writeInputType" size="mini">
                                                <el-radio :label="0">{{$t('systemSetting.TextBox')}}</el-radio>
                                                <el-radio :label="1">{{$t('systemSetting.NumberBox')}}</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <el-form-item style="width: 40%"></el-form-item>
                                    </template>
                                </div>
                                <div class="ringFormItem"  v-if="item.type !== 1">

                                    <template v-if="item.writeType  == 1">
                                        <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.btnName" :placeholder="$t('systemSetting.btnCNName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.btnNameEn" :placeholder="$t('systemSetting.btnENName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnValue')"  required><el-input v-model="item.btnInputDefault" :placeholder="$t('systemSetting.Default')"></el-input></el-form-item>
                                        <el-form-item></el-form-item>
                                        <el-form-item></el-form-item>
                                    </template>
                                    <template v-else-if="item.writeType  == 2">
                                        <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.btnName" :placeholder="$t('systemSetting.btnCNName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.btnNameEn" :placeholder="$t('systemSetting.btnENName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.Default')"><el-input v-model="item.btnInputDefault" :placeholder="$t('systemSetting.Default')"></el-input></el-form-item>
                                        <template v-if="item.writeInputType == 1">
                                            <el-form-item :label="$t('systemSetting.max')"><el-input v-model="item.max" oninput="value=value.replace(/[^\-?\d.]/g,'')"></el-input></el-form-item>
                                            <el-form-item :label="$t('systemSetting.min')"><el-input v-model="item.min" oninput="value=value.replace(/[^\-?\d.]/g,'')"></el-input></el-form-item>
                                        </template>
                                        <template v-else>
                                            <el-form-item style="width: 40%"></el-form-item>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <el-form-item :label="$t('systemSetting.btnCNName')" required><el-input v-model="item.btnName" :placeholder="$t('systemSetting.btnCNName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.btnENName')" required><el-input v-model="item.btnNameEn" :placeholder="$t('systemSetting.btnENName')"></el-input></el-form-item>
                                        <el-form-item :label="$t('systemSetting.Default')"><el-input v-model="item.btnInputDefault" placeholder=""></el-input></el-form-item>
                                        <div class="el-form-item1" style="width: 40%;">
                                            <div class="dictBox"  v-if="(item.type === 2 && item.writeType === 3)">
                                                <div style="display: flex; padding-left: 12px;">
                                                    <el-form-item :label="$t('systemSetting.attrKeyName')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.key" style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item :label="$t('systemSetting.attrKeyValue')"  style="width: 40%; padding-right: 5px" label-width="50"><el-input placeholder="" v-model="item.value"  style="width: 70px"></el-input></el-form-item>
                                                    <el-form-item label-width="60" style="width: auto;  padding-right: 5px"> <el-color-picker v-model="item.color"></el-color-picker></el-form-item>
                                                    <div style="width: auto">
                                                        <el-button size="mini" @click="addDict(false, index)">{{$t('ems.add')}}</el-button>
                                                    </div>
                                                </div>
                                                <el-table :data="item.readDict" style="width: 100%" border size="mini" height="150" class="minRingTable">
                                                    <el-table-column  :label="$t('systemSetting.attrKeyName')" prop="key">
                                                        <template slot-scope="scope">
                                                            <span v-if="scope.row.color" :style="{ color: scope.row.color }">{{ scope.row.key }}</span>
                                                            <span v-else>{{ scope.row.key }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column  :label="$t('systemSetting.attrKeyValue')" prop="value"></el-table-column>
                                                    <el-table-column  :label="$t('ems.alarm.operation')" align="center">
                                                        <template slot-scope="scope">
                                                            <el-button @click.native.prevent="deleteDict(false, index, scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="deleteBtn">
                                    <el-button size="mini" @click="remove(false, index)">{{ $t('ems.alarm.delete') }}</el-button>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="emptyText">{{$t('systemSetting.addTips')}}</div>
                        </template>
                    </div>
                </div>
            </el-form>
            <div class="preview">
                <div class="previewTitle">{{$t('systemSetting.Preview')}}</div>
                <div class="dynamic-item">
                    <div class="item-container">
                        <RingSingle :ringData ="addForm" :deviceData="deviceData"></RingSingle>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <el-button size="small" @click="close(false)">{{ $t('ems.strategy.cancel') }}</el-button>
            <el-button size="small" type="primary" @click="subminAdd" :loading="saveLoading">{{ $t('ems.strategy.confirm') }}</el-button>
        </div>
    </div>
</template>

<script>
    import i18n from "@/lang";
    import RingSingle from "@/view/Container/newDyRing/RingSingle";
    import { saveEnvTemp } from "@/api/spms";
    import moment from "moment";

    export default {
        name: "ringAdd",
        components: { RingSingle },
        props: ['activeRow', "envSort"],
        data(){
            return {
                addForm: {
                    frontPage: [],
                    backPage: [],
                    envIcon: 0,
                    envName: 'test',
                    envNameEn: 'test',
                    envSort: 1,
                    enabled: 1,
                },
                addVisible:  false,
                roleList: [],
                rules: {
                    account: { required: true, message: i18n.t("ems.accountInputTip"), trigger: 'blur' },
                    realName: { required: true, message: i18n.t("ems.realNameInputTip"), trigger: 'blur' },
                    roleId: { required: true, message: i18n.t("ems.selectRoleTip"), trigger: 'change' },
                },

                iconOption:[
                    {name: i18n.t("systemSetting.Default"), value: 0},
                    {name: i18n.t("systemSetting.airconditioner"), value: 1},
                    {name: i18n.t("systemSetting.Firefighting"), value: 2},
                    {name: i18n.t("systemSetting.WaterFlooding"), value: 3},
                    {name: 'UPS', value: 4},
                    {name: i18n.t("systemSetting.LiquidCooling"), value: 5},
                ],

                deviceData:  {
                    online:  true,
                    deviceNo: 'device name test',
                    collectTime: moment().format("YYYY-MM-DD HH:mm:ss")
                },

                saveLoading: false,
            }
        },
        mounted(){
            if(this.activeRow && this.activeRow.envAttrs){
                const { envName, envNameEn, envSort, enabled, envIcon} = this.activeRow;
                this.addForm.envName = envName;
                this.addForm.envNameEn = envNameEn;
                this.addForm.envSort = envSort;
                this.addForm.enabled = enabled;
                this.addForm.envIcon = envIcon;
                this.addForm.frontPage = this.activeRow.envAttrs.filter(i => i.isfront == true );
                this.addForm.backPage = this.activeRow.envAttrs.filter(i => i.isfront == false );
            }else{
                this.addForm.envSort = this.envSort;
            }
        },
        methods: {
            subminAdd(){
                if(this.saveLoading) return false;
                if(this.addForm.envName == "" || this.addForm.envNameEn == ""){
                    this.$message.error(i18n.t("systemSetting.ringAddTips"));
                    return false;
                }
                if(this.addForm.envSort  == "" ){
                    this.$message.error(i18n.t("systemSetting.ringAddTips1"));
                    return false;
                }
                for(let item of this.addForm.frontPage){
                    if(item.sort == "" ){
                        this.$message.error(i18n.t("systemSetting.ringAddTips2"));
                        return false;
                    }
                    if(item.name == ""  || item.nameEn == ""){
                        this.$message.error(i18n.t("systemSetting.ringAddTips3"));
                        return false;
                    }
                    if(item.type == 1){
                        if(item.readIdentifier == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips4"));
                            return false;
                        }
                        if(item.readTag == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips5"));
                            return false;
                        }
                        if(item.hasDict && item.readDict.length === 0){
                            this.$message.error(i18n.t("systemSetting.ringAddTips6"));
                            return false;
                        }
                    }

                    if(item.type == 2){
                        if(item.writeIdentifier == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips7"));
                            return false;
                        }
                        if(item.writeTag == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips8"));
                            return false;
                        }

                        if(item.btnName == ""  || item.btnNameEn == ""){
                            this.$message.error(i18n.t("systemSetting.ringAddTips9"));
                            return false;
                        }
                        if(item.writeType == 3 && item.readDict.length === 0){
                            this.$message.error(i18n.t("systemSetting.ringAddTips6"));
                            return false;
                        }

                        if(item.writeType == 1 && item.btnInputDefault === ''){
                            this.$message.error(i18n.t("systemSetting.ringAddTips10"));
                            return false;
                        }
                    }
                }
                for(let item of this.addForm.backPage){
                    if(item.sort == "" ){
                        this.$message.error(i18n.t("systemSetting.ringAddTips2"));
                        return false;
                    }
                    if(item.name == ""  || item.nameEn == ""){
                        this.$message.error(i18n.t("systemSetting.ringAddTips3"));
                        return false;
                    }
                    if(item.type == 1){
                        if(item.readIdentifier == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips4"));
                            return false;
                        }
                        if(item.readTag == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips5"));
                            return false;
                        }
                        if(item.hasDict && item.readDict.length === 0){
                            this.$message.error(i18n.t("systemSetting.ringAddTips6"));
                            return false;
                        }
                    }

                    if(item.type == 2){
                        if(item.writeIdentifier == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips7"));
                            return false;
                        }
                        if(item.writeTag == "" ){
                            this.$message.error(i18n.t("systemSetting.ringAddTips8"));
                            return false;
                        }

                        if(item.btnName == ""  || item.btnNameEn == ""){
                            this.$message.error(i18n.t("systemSetting.ringAddTips9"));
                            return false;
                        }
                        if(item.writeType == 3 && item.readDict.length === 0){
                            this.$message.error(i18n.t("systemSetting.ringAddTips6"));
                            return false;
                        }

                        if(item.writeType == 1 && item.btnInputDefault === ''){
                            this.$message.error(i18n.t("systemSetting.ringAddTips10"));
                            return false;
                        }
                    }
                }

                const {envName, envNameEn, envSort, enabled, envIcon} = this.addForm;
                const params = {envName, envNameEn, envSort, enabled, envIcon} ;
                if(this.activeRow && this.activeRow.id){
                    params.id = this.activeRow.id;
                }
                const frontPage1 = this.addForm.frontPage.map(i => { i.isfront = true; return i});
                const backPage1 = this.addForm.backPage.map(i => { i.isfront = false; return i});
                params.envAttrs = [...frontPage1, ...backPage1];
                params.envAttrs = params.envAttrs.sort((a,b) => (+a.sort) - (+b.sort));
                this.saveLoading = true;
                saveEnvTemp(params).then(res => {
                    this.saveLoading = false;
                    if(res && res.data  && res.data.success){
                        this.$emit("close", true);
                        this.$message.success(i18n.t("ems.SuccessfulOperation"));
                    }else{
                        this.$message.success(i18n.t("ems.operationFailed"));
                    }
                }).catch(err => {
                    this.saveLoading = false;
                    console.log(err);
                    this.$message.success(i18n.t("ems.operationFailed"));
                });
            },
            close(flag){
                this.$emit('close', flag);
            },
            add(flag){
               if(flag){
                   const length = this.addForm.frontPage.length;
                   this.addForm.frontPage.push({
                       type: 1,
                       writeType: 1,
                       writeInputType: 0,
                       sort: length + 1,
                       name: '',
                       nameEn: '',
                       unit: '',
                       readDict: [

                       ],
                       "readIdentifier": "",
                       "readTag": "",
                       "writeIdentifier": "",
                       "writeTag": "",
                       key: '',
                       value: '',
                       btnName: '命令下发',
                       btnNameEn: 'Send Down',
                       btnDownValue: '',
                       btnInputDefault: '',
                       max:'',
                       min:'',
                   });
               } else{
                   const length = this.addForm.backPage.length;
                   this.addForm.backPage.push({
                       type: 1,
                       writeType: 1,
                       writeInputType: 0,
                       sort: length + 1,
                       name: '',
                       nameEn: '',
                       unit: '',
                       readDict: [

                       ],
                       "readIdentifier": "",
                       "readTag": "",
                       "writeIdentifier": "",
                       "writeTag": "",
                       key: '',
                       value: '',
                       btnName: '命令下发',
                       btnNameEn: 'Send Down',
                       btnDownValue: '',
                       btnInputDefault: '',
                       max:'',
                       min:'',
                   });
               }
            },
            remove(flag, index){
                if(flag){
                    this.addForm.frontPage.splice(index, 1);
                }else{
                    this.addForm.backPage.splice(index, 1);
                }
                this.$forceUpdate();
            },
            addDict(flag, index){
                if(flag){
                    if(this.addForm.frontPage[index].key == "" || this.addForm.frontPage[index].value == ""){
                        this.$message.warning(i18n.t("systemSetting.ringAddTips11"));
                        return false;
                    }
                    let ids = this.addForm.frontPage[index].readDict.map((m)=>{ return m.id });
                    let maxId = ids.length > 0 ? Math.max(...ids) : 0;
                    this.addForm.frontPage[index].readDict.push(
                        { key: this.addForm.frontPage[index].key, value: this.addForm.frontPage[index].value, id: maxId + 1, color: this.addForm.frontPage[index].color}
                    );
                    console.log(this.addForm.frontPage[index].readDict);

                    this.addForm.frontPage[index].key = "";
                    this.addForm.frontPage[index].value = "";
                    this.addForm.frontPage[index].color = null;
                }else{
                    if(this.addForm.backPage[index].key == "" || this.addForm.backPage[index].value == ""){
                        this.$message.warning(i18n.t("systemSetting.ringAddTips11"));
                        return false;
                    }
                    let ids = this.addForm.backPage[index].readDict.map((m)=>{ return m.id });
                    let maxId = ids.length > 0 ? Math.max(...ids) : 0;
                    this.addForm.backPage[index].readDict.push(
                        { key: this.addForm.backPage[index].key, value: this.addForm.backPage[index].value, id: maxId + 1, color:  this.addForm.backPage[index].color}
                    );
                    this.addForm.backPage[index].key = "";
                    this.addForm.backPage[index].value = "";
                    this.addForm.backPage[index].color = null;
                }
                this.$forceUpdate();
            },
            deleteDict(flag, index, id){
                if(flag){
                    this.addForm.frontPage[index].readDict.forEach((item,key) => {
                        if(item.id == id){
                         this.addForm.frontPage[index].readDict.splice(key, 1)
                        }
                    });
                }else{
                    this.addForm.backPage[index].readDict.forEach((item,key) => {
                        if(item.id == id){
                          this.addForm.backPage[index].readDict.splice(key, 1)
                        }
                    });
                }
                this.$forceUpdate();
            }
        }
    }
</script>

<style scoped lang="scss">
    .ringAdd{
        width: 100%;
        height: 100%;
        position: relative;

        .ringMain{
            width: 100%;
            display: flex;
        }
        .preview{
            flex: 1;
            margin: 0 10px;
            background-color: #0a0a0a;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .previewTitle{
                position: absolute;
                top: 10px;
                left: 10px;
                height: 40px;
                font-size: 24px;
                color:  var(--font_bright_blue);
            }
        }

        .dynamic-item {
            width: 100%;
            height: 425px;
            box-sizing: border-box;
            /*margin-bottom: 20px;*/
            display: flex;
            justify-content: center;
            align-items: center;

            .item-container {
                width: 430px;
                height: 412px;
                box-sizing: border-box;
            }
        }

        .ringForm{
            width: 1100px;
            background-color: black;
            padding-top: 10px;
            padding-bottom: 10px;
            .ringFormHead{
                display: flex;
                width: 100%;
                justify-content: center;
                padding-left: 10px;
                .el-form-item{
                    margin-right: 20px;
                }
            }

            .fieldBox{
                height: 600px;
                overflow-y: auto;
                .frontBackPage{
                    border: #7a7a7a solid 1px;
                    margin-bottom: 10px;
                    margin-left: 10px;
                    margin-right: 10px;
                    min-height: 100px;
                    .pageTitle{
                        font-size: 18px;
                        color: #a6a6a6;
                        margin-left: 10px;
                    }

                    .fieldItem{
                        background-color: #161616;
                        margin: 10px;
                        position: relative;
                        padding-top: 10px;
                        .deleteBtn{
                            padding: 5px;
                            /*width: 100%;*/
                            text-align: right;
                        }

                        .ringFormItem{
                            display: flex;
                            width: 100%;
                            padding-left: 10px;
                            .el-form-item{
                                padding-right: 16px;
                                margin-bottom: 10px;
                                width: 20%;
                                line-height: 28px;
                                box-sizing: border-box;
                            }
                            .el-form-item1{
                                padding-right: 20px;
                                margin-bottom: 10px;
                                line-height: 28px;
                                width: 20%;
                                box-sizing: border-box;
                            }
                            .el-radio{
                                margin-right: 12px !important;
                                .el-radio__label {
                                    font-size: 14px !important;
                                    color: rgb(128, 128, 128);
                                }
                            }
                            .dictBox{
                                width: 100%;
                                background-color: rgb(30, 30, 30);
                                line-height: 20px;
                                box-sizing: border-box;
                                padding: 5px;
                            }
                        }
                    }

                    .emptyText{
                        width: 100%;
                        margin-top: 20px;
                        font-size: 16px;
                        color: #a1a1a1;
                        text-align: center;
                    }
                }
            }

        }

        .footer{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 5px;
        }
    }
</style>
<style lang="scss">
    .ringFormItem{
        .el-radio{
            margin-right: 12px !important;
            .el-radio__label {
                font-size: 14px !important;
                color: rgb(128, 128, 128);
            }
        }
    }

</style>